/**
 * The React 19 overlay root for the M2 station and title screens (D-011, M2 plan §2.8).
 * `#ui-root` sits between `#hud` and `#overlay` in index.html, so the pause menu stays on top.
 * M2-18 mounts it once through the station feature and renders `<App />` into it.
 */
import type { ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import './ui.css'

export interface UiRoot {
  /** Render (or re-render) the whole overlay tree. */
  render(node: ReactNode): void
  /** Tear the tree down; the root cannot be rendered into again afterwards. */
  unmount(): void
}

export function mountUiRoot(el: HTMLElement): UiRoot {
  const root = createRoot(el)
  let mounted = true
  return {
    render(node: ReactNode): void {
      if (mounted) root.render(node)
    },
    unmount(): void {
      if (!mounted) return
      mounted = false
      root.unmount()
    },
  }
}
